/* eslint-disable react/no-unknown-property */
/* eslint-disable react/prop-types */
import React, { Component } from "react";
import SubHeader from "../Components/SubHeader";
import Header from "../Components/Header";
import Footer from "../Components/Footer";
import {
  MapPin,
  Calendar,
  Clock,
  Users,
  Tag,
  ChevronRight,
  Filter,
  Search,
  Star,
  Building2,
  Bookmark,
  ExternalLink,
  X,
  ChevronDown,
  ChevronUp,
  BarChart3,
} from "lucide-react";
import Cookies from "js-cookie";

class WebEtkinlikFilter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filters: {
        category: "",
        city: "",
        district: "",
        searchTerm: "",
      },
    };
  }

  getUniqueValues = (field) => {
    const { etkinlikler } = this.props;
    const values = etkinlikler.map((e) => {
      if (field === "category") return e.tag;
      return e[field];
    });
    return [...new Set(values)].filter(Boolean);
  };

  handleFilterChange = (field, value) => {
    const newFilters = { ...this.state.filters, [field]: value };
    this.setState({ filters: newFilters });
    this.props.onFilterChange(newFilters);
  };

  clearFilters = () => {
    const clearedFilters = {
      category: "",
      city: "",
      district: "",
      searchTerm: "",
    };
    this.setState({ filters: clearedFilters });
    this.props.onFilterChange(clearedFilters);
  };

  render() {
    const { filters } = this.state;
    const categories = this.getUniqueValues("category");
    const cities = this.getUniqueValues("city");
    const districts = this.getUniqueValues("district");

    const activeFilterCount = Object.values(filters).filter((v) => v).length;

    return (
      <div
        style={{
          background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
          border: "none",
          borderRadius: "16px",
          margin: "20px 0",
          boxShadow: "0 10px 30px rgba(102, 126, 234, 0.3)",
          overflow: "hidden",
        }}
      >
        <div
          style={{
            padding: "20px 28px",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "10px",
              color: "white",
              fontWeight: "600",
              fontSize: "16px",
              marginBottom: "20px",
            }}
          >
            <Filter size={20} />
            <span>Filtreler</span>
            {activeFilterCount > 0 && (
              <span
                style={{
                  background: "#ff6b6b",
                  color: "white",
                  borderRadius: "50%",
                  width: "24px",
                  height: "24px",
                  fontSize: "12px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontWeight: "700",
                  boxShadow: "0 2px 8px rgba(255, 107, 107, 0.4)",
                }}
              >
                {activeFilterCount}
              </span>
            )}
          </div>

          <div
            className="filter-grid"
            style={{
              display: "grid",
              gridTemplateColumns: "1fr 1fr 1fr 2fr auto",
              gap: "15px",
              alignItems: "center",
            }}
          >
            <select
              value={filters.category}
              onChange={(e) =>
                this.handleFilterChange("category", e.target.value)
              }
              style={{
                width: "100%",
                padding: "12px 16px",
                border: "2px solid rgba(255,255,255,0.2)",
                borderRadius: "10px",
                fontSize: "14px",
                background: "rgba(255,255,255,0.15)",
                color: "white",
                cursor: "pointer",
                fontWeight: "500",
                backdropFilter: "blur(10px)",
                transition: "all 0.3s ease",
              }}
              onFocus={(e) => {
                e.target.style.background = "rgba(255,255,255,0.25)";
                e.target.style.borderColor = "rgba(255,255,255,0.4)";
              }}
              onBlur={(e) => {
                e.target.style.background = "rgba(255,255,255,0.15)";
                e.target.style.borderColor = "rgba(255,255,255,0.2)";
              }}
            >
              <option value="" style={{ color: "#374151" }}>
                🏷️ Tüm Kategoriler
              </option>
              {categories.map((category) => (
                <option
                  key={category}
                  value={category}
                  style={{ color: "#374151" }}
                >
                  #{category}
                </option>
              ))}
            </select>

            <select
              value={filters.city}
              onChange={(e) => this.handleFilterChange("city", e.target.value)}
              style={{
                width: "100%",
                padding: "12px 16px",
                border: "2px solid rgba(255,255,255,0.2)",
                borderRadius: "10px",
                fontSize: "14px",
                background: "rgba(255,255,255,0.15)",
                color: "white",
                cursor: "pointer",
                fontWeight: "500",
                backdropFilter: "blur(10px)",
                transition: "all 0.3s ease",
              }}
              onFocus={(e) => {
                e.target.style.background = "rgba(255,255,255,0.25)";
                e.target.style.borderColor = "rgba(255,255,255,0.4)";
              }}
              onBlur={(e) => {
                e.target.style.background = "rgba(255,255,255,0.15)";
                e.target.style.borderColor = "rgba(255,255,255,0.2)";
              }}
            >
              <option value="" style={{ color: "#374151" }}>
                🏙️ Tüm Şehirler
              </option>
              {cities.map((city) => (
                <option key={city} value={city} style={{ color: "#374151" }}>
                  {city}
                </option>
              ))}
            </select>

            <select
              value={filters.district}
              onChange={(e) =>
                this.handleFilterChange("district", e.target.value)
              }
              disabled={!filters.city}
              style={{
                width: "100%",
                padding: "12px 16px",
                border: "2px solid rgba(255,255,255,0.2)",
                borderRadius: "10px",
                fontSize: "14px",
                background: filters.city
                  ? "rgba(255,255,255,0.15)"
                  : "rgba(255,255,255,0.08)",
                color: filters.city ? "white" : "rgba(255,255,255,0.5)",
                cursor: filters.city ? "pointer" : "not-allowed",
                fontWeight: "500",
                backdropFilter: "blur(10px)",
                transition: "all 0.3s ease",
              }}
              onFocus={(e) => {
                if (filters.city) {
                  e.target.style.background = "rgba(255,255,255,0.25)";
                  e.target.style.borderColor = "rgba(255,255,255,0.4)";
                }
              }}
              onBlur={(e) => {
                e.target.style.background = filters.city
                  ? "rgba(255,255,255,0.15)"
                  : "rgba(255,255,255,0.08)";
                e.target.style.borderColor = "rgba(255,255,255,0.2)";
              }}
            >
              <option value="" style={{ color: "#374151" }}>
                🏘️ Tüm İlçeler
              </option>
              {districts
                .filter((d) => {
                  if (!filters.city) return false;
                  return this.props.etkinlikler.some(
                    (e) => e.city === filters.city && e.district === d
                  );
                })
                .map((district) => (
                  <option
                    key={district}
                    value={district}
                    style={{ color: "#374151" }}
                  >
                    {district}
                  </option>
                ))}
            </select>

            <div className="search-full-width" style={{ position: "relative" }}>
              <input
                type="text"
                placeholder="🔍 Etkinlik adı, venue, şehir ara..."
                value={filters.searchTerm}
                onChange={(e) =>
                  this.handleFilterChange("searchTerm", e.target.value)
                }
                style={{
                  width: "100%",
                  padding: "12px 16px 12px 44px",
                  border: "2px solid rgba(255,255,255,0.2)",
                  borderRadius: "10px",
                  fontSize: "14px",
                  background: "rgba(255,255,255,0.15)",
                  color: "white",
                  fontWeight: "500",
                  backdropFilter: "blur(10px)",
                  transition: "all 0.3s ease",
                }}
                onFocus={(e) => {
                  e.target.style.background = "rgba(255,255,255,0.25)";
                  e.target.style.borderColor = "rgba(255,255,255,0.4)";
                }}
                onBlur={(e) => {
                  e.target.style.background = "rgba(255,255,255,0.15)";
                  e.target.style.borderColor = "rgba(255,255,255,0.2)";
                }}
              />
              <Search
                size={18}
                style={{
                  position: "absolute",
                  left: "14px",
                  top: "50%",
                  transform: "translateY(-50%)",
                  color: "rgba(255,255,255,0.7)",
                }}
              />
            </div>

            {activeFilterCount > 0 && (
              <button
                className="clear-button"
                onClick={this.clearFilters}
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                  padding: "12px 20px",
                  background: "rgba(255, 107, 107, 0.9)",
                  color: "white",
                  border: "none",
                  borderRadius: "10px",
                  fontSize: "14px",
                  fontWeight: "600",
                  cursor: "pointer",
                  transition: "all 0.3s ease",
                  boxShadow: "0 4px 15px rgba(255, 107, 107, 0.3)",
                  backdropFilter: "blur(10px)",
                  whiteSpace: "nowrap",
                }}
              >
                <X size={16} />
                Temizle
              </button>
            )}
          </div>

          <style jsx>{`
            @media (max-width: 1200px) {
              .filter-grid {
                grid-template-columns: 1fr 1fr 1fr !important;
                grid-template-rows: auto auto auto;
              }
              .search-full-width {
                grid-column: 1 / -1 !important;
                margin-top: 15px;
              }
              .clear-button {
                grid-column: 1 / -1 !important;
                justify-self: center;
                margin-top: 15px;
              }
            }

            @media (max-width: 768px) {
              .filter-grid {
                grid-template-columns: 1fr !important;
                gap: 15px;
              }
              .search-full-width {
                grid-column: 1 !important;
                margin-top: 0;
              }
              .clear-button {
                grid-column: 1 !important;
                margin-top: 0;
                justify-self: stretch;
              }
            }
          `}</style>
        </div>

        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            padding: "16px 28px",
            background: "rgba(255,255,255,0.1)",
            backdropFilter: "blur(10px)",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "10px",
              fontSize: "15px",
              color: "white",
              fontWeight: "500",
            }}
          >
            <BarChart3 size={18} />
            <span>📊 {this.props.resultCount || 0} etkinlik bulundu</span>
          </div>

          <div
            style={{
              fontSize: "13px",
              color: "rgba(255,255,255,0.8)",
              fontWeight: "500",
            }}
          >
            📄 Sayfa 1 / {Math.ceil((this.props.resultCount || 0) / 12)}
          </div>
        </div>
      </div>
    );
  }
}
export default class Etkinlikler extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filters: {
        category: "",
        city: "",
        district: "",
        searchTerm: "",
      },
      etkinlikler: [
        {
          id: 1,
          title: "Kocaeli İş Fırsat Sunumu",
          location: "Kocaeli/Darıca",
          city: "Kocaeli",
          district: "Darıca",
          date: "03.01.2025",
          time: "20:30",
          tag: "opp/iş fırsat",
          tagColor: "#ef4444",
          image:
            "https://images.unsplash.com/photo-1560472354-b33ff0c44a43?w=600",
          description:
            "Kocaeli bölgesinde düzenlenecek iş fırsat sunumu etkinliği. Yeni iş ortaklıkları ve gelir fırsatları hakkında bilgi alabilirsiniz.",
          venue: "Has-Er Grand Salon",
          address:
            "İnönü Mahallesi Paşa Mah. İstasyon Cad. No:235 Darıca/Kocaeli",
          participants: 150,
          status: "active",
        },
        {
          id: 2,
          title: "NDO Akademi Eğitim Semineri",
          location: "İstanbul/Şişli",
          city: "İstanbul",
          district: "Şişli",
          date: "05.01.2025",
          time: "19:00",
          tag: "ndo/akademi",
          tagColor: "#10b981",
          image:
            "https://images.unsplash.com/photo-1524178232363-1fb2b075b655?w=600",
          description:
            "NDO Akademi eğitim programları hakkında detaylı bilgi sunumu ve kayıt işlemleri.",
          venue: "Şişli Konferans Merkezi",
          address: "Mecidiyeköy Mahallesi Büyükdere Cad. No:102 Şişli/İstanbul",
          participants: 200,
          status: "active",
        },
        {
          id: 3,
          title: "BBS İş Geliştirme Toplantısı",
          location: "Ankara/Çankaya",
          city: "Ankara",
          district: "Çankaya",
          date: "08.01.2025",
          time: "18:30",
          tag: "bbs",
          tagColor: "#3b82f6",
          image:
            "https://images.unsplash.com/photo-1552664730-d307ca884978?w=600",
          description:
            "BBS sistemi ve iş geliştirme stratejileri üzerine interaktif toplantı.",
          venue: "Çankaya İş Merkezi",
          address: "Kızılay Mahallesi Atatürk Bulvarı No:45 Çankaya/Ankara",
          participants: 80,
          status: "active",
        },
        {
          id: 4,
          title: "Kafe Sunumu - Networking",
          location: "İzmir/Bornova",
          city: "İzmir",
          district: "Bornova",
          date: "10.01.2025",
          time: "20:00",
          tag: "kafesunumu",
          tagColor: "#8b5cf6",
          image:
            "https://images.unsplash.com/photo-1556761175-4b46a572b786?w=600",
          description: "Rahat bir ortamda networking ve iş fırsatları sunumu.",
          venue: "Bornova Kafe & Kültür",
          address:
            "Ege Üniversitesi Mahallesi Gençlik Cad. No:78 Bornova/İzmir",
          participants: 50,
          status: "active",
        },
        {
          id: 5,
          title: "Bursa Mega Etkinlik",
          location: "Bursa/Osmangazi",
          city: "Bursa",
          district: "Osmangazi",
          date: "15.01.2025",
          time: "19:30",
          tag: "mega etkinlik",
          tagColor: "#f59e0b",
          image:
            "https://images.unsplash.com/photo-1505373877841-8d25f7d46678?w=600",
          description:
            "Bursa'nın en büyük iş fırsat sunumu ve networking etkinliği.",
          venue: "Bursa Büyükşehir Belediyesi Kültür Merkezi",
          address: "Santral Garaj Mahallesi Stadyum Cad. No:1 Osmangazi/Bursa",
          participants: 500,
          status: "active",
        },
        {
          id: 6,
          title: "Online Dijital Pazarlama Semineri",
          location: "Online",
          city: "Online",
          district: "Online",
          date: "12.01.2025",
          time: "21:00",
          tag: "online/dijital",
          tagColor: "#06b6d4",
          image:
            "https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=600",
          description:
            "Dijital pazarlama stratejileri ve online iş modelleri hakkında kapsamlı eğitim.",
          venue: "Zoom Platform",
          address: "Online Katılım",
          participants: 300,
          status: "active",
        },
      ],
      filteredEtkinlikler: [],
      selectedEtkinlik: null,
    };
  }

  componentDidMount() {
    this.setState({ filteredEtkinlikler: this.state.etkinlikler });
  }

  handleFilterChange = (filters) => {
    this.setState({ filters }, this.applyFilters);
  };

  applyFilters = () => {
    const { etkinlikler, filters } = this.state;

    let filtered = etkinlikler;

    if (filters.category) {
      filtered = filtered.filter(
        (etkinlik) => etkinlik.tag === filters.category
      );
    }

    if (filters.city) {
      filtered = filtered.filter((etkinlik) => etkinlik.city === filters.city);
    }

    if (filters.district) {
      filtered = filtered.filter(
        (etkinlik) => etkinlik.district === filters.district
      );
    }

    if (filters.searchTerm) {
      const searchTerm = filters.searchTerm.toLowerCase();
      filtered = filtered.filter(
        (etkinlik) =>
          etkinlik.title.toLowerCase().includes(searchTerm) ||
          etkinlik.city.toLowerCase().includes(searchTerm) ||
          etkinlik.district.toLowerCase().includes(searchTerm) ||
          etkinlik.venue.toLowerCase().includes(searchTerm)
      );
    }

    this.setState({ filteredEtkinlikler: filtered });
  };

  handleEtkinlikView = (etkinlik) => {
    this.setState({ selectedEtkinlik: etkinlik });
  };

  handleBackToList = () => {
    this.setState({ selectedEtkinlik: null });
  };

  render() {
    const { filteredEtkinlikler, selectedEtkinlik } = this.state;

    if (selectedEtkinlik) {
      return (
        <>
          <SubHeader />
          <Header
            isLoggedIn={Cookies.get("token") == null ? false : true}
            userName="Mehmet Özkan"
          />

          <div
            style={{
              background: "#000",
              minHeight: "100vh",
              position: "relative",
            }}
          >
            <button
              onClick={this.handleBackToList}
              style={{
                position: "absolute",
                top: "20px",
                left: "20px",
                background: "rgba(0,0,0,0.8)",
                color: "white",
                border: "none",
                padding: "12px 20px",
                borderRadius: "25px",
                fontSize: "14px",
                fontWeight: "600",
                cursor: "pointer",
                zIndex: 10,
                display: "flex",
                alignItems: "center",
                gap: "8px",
              }}
            >
              ← Geri Dön
            </button>

            <div
              style={{
                width: "100%",
                height: "100vh",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                padding: "20px",
              }}
            >
              <img
                src={selectedEtkinlik.image}
                alt={selectedEtkinlik.title}
                style={{
                  maxWidth: "100%",
                  maxHeight: "100%",
                  objectFit: "contain",
                  borderRadius: "12px",
                  boxShadow: "0 20px 60px rgba(0,0,0,0.5)",
                }}
              />
            </div>

            <div
              style={{
                position: "absolute",
                bottom: "20px",
                left: "20px",
                right: "20px",
                background: "rgba(0,0,0,0.8)",
                color: "white",
                padding: "20px",
                borderRadius: "12px",
                backdropFilter: "blur(10px)",
              }}
            >
              <h3
                style={{
                  margin: "0 0 10px 0",
                  fontSize: "24px",
                  fontWeight: "600",
                }}
              >
                {selectedEtkinlik.title}
              </h3>
              <div
                style={{
                  display: "flex",
                  gap: "20px",
                  flexWrap: "wrap",
                  alignItems: "center",
                }}
              >
                <div
                  style={{ display: "flex", alignItems: "center", gap: "6px" }}
                >
                  <MapPin size={16} />
                  {selectedEtkinlik.location}
                </div>
                <div
                  style={{ display: "flex", alignItems: "center", gap: "6px" }}
                >
                  <Calendar size={16} />
                  {selectedEtkinlik.date} • {selectedEtkinlik.time}
                </div>
                <div
                  style={{
                    background: selectedEtkinlik.tagColor,
                    color: "white",
                    padding: "4px 12px",
                    borderRadius: "20px",
                    fontSize: "12px",
                    fontWeight: "600",
                  }}
                >
                  #{selectedEtkinlik.tag}
                </div>
              </div>
            </div>
          </div>

          <Footer />
        </>
      );
    }

    return (
      <>
        <SubHeader />
        <Header
          isLoggedIn={Cookies.get("token") == null ? false : true}
          userName="Mehmet Özkan"
        />
        <div style={{ background: "#f8fafc", minHeight: "100vh" }}>
          <div
            style={{
              background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
              padding: "80px 0 60px",
              position: "relative",
              overflow: "hidden",
            }}
          >
            <div
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                background:
                  "linear-gradient(45deg, transparent 30%, rgba(255,255,255,0.1) 50%, transparent 70%)",
                pointerEvents: "none",
              }}
            />

            <div
              className="container"
              style={{ position: "relative", zIndex: 1 }}
            >
              <div className="row">
                <div className="text-center">
                  <h6
                    style={{
                      color: "rgba(255,255,255,0.8)",
                      fontSize: "14px",
                      fontWeight: "600",
                      letterSpacing: "1px",
                      textTransform: "uppercase",
                      marginBottom: "15px",
                    }}
                  >
                    🎯 ETKİNLİKLER
                  </h6>
                  <h1
                    style={{
                      color: "white",
                      fontSize: "42px",
                      fontWeight: "700",
                      marginBottom: "20px",
                      lineHeight: "1.2",
                    }}
                  >
                    Etkinlikler / Afişler
                  </h1>
                </div>
              </div>
            </div>
          </div>

          <div style={{ padding: "40px 0", background: "white" }}>
            <div className="container">
              <div className="row">
                <div className="col-12">
                  <WebEtkinlikFilter
                    onFilterChange={this.handleFilterChange}
                    etkinlikler={this.state.etkinlikler}
                    resultCount={filteredEtkinlikler.length}
                  />
                </div>
              </div>
            </div>
          </div>

          <div style={{ padding: "40px 0 80px" }}>
            <div className="container">
              {filteredEtkinlikler.length === 0 ? (
                <div
                  style={{
                    textAlign: "center",
                    padding: "60px 20px",
                    background: "white",
                    borderRadius: "16px",
                    boxShadow: "0 15px 40px rgba(0,0,0,0.08)",
                  }}
                >
                  <div
                    style={{
                      fontSize: "64px",
                      marginBottom: "20px",
                    }}
                  >
                    🔍
                  </div>
                  <h3
                    style={{
                      fontSize: "24px",
                      fontWeight: "600",
                      color: "#1e293b",
                      marginBottom: "10px",
                    }}
                  >
                    Etkinlik Bulunamadı
                  </h3>
                  <p
                    style={{
                      color: "#64748b",
                      fontSize: "16px",
                    }}
                  >
                    Aradığınız kriterlere uygun etkinlik bulunamadı. Filtreleri
                    temizleyerek tekrar deneyin.
                  </p>
                </div>
              ) : (
                <div className="row">
                  {filteredEtkinlikler.map((etkinlik) => (
                    <div key={etkinlik.id} className="col-lg-6 col-xl-4 mb-30">
                      <div
                        className="etkinlik-card"
                        style={{
                          background:
                            "linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)",
                          borderRadius: "20px",
                          overflow: "hidden",
                          boxShadow: "0 15px 40px rgba(0,0,0,0.08)",
                          border: "1px solid rgba(226, 232, 240, 0.5)",
                          height: "100%",
                          display: "flex",
                          flexDirection: "column",
                          position: "relative",
                        }}
                      >
                        <div style={{ position: "relative", height: "220px" }}>
                          <img
                            src={etkinlik.image}
                            alt={etkinlik.title}
                            style={{
                              width: "100%",
                              height: "100%",
                              objectFit: "cover",
                            }}
                          />

                          <div
                            style={{
                              position: "absolute",
                              top: "15px",
                              right: "15px",
                              background: etkinlik.tagColor,
                              color: "white",
                              padding: "6px 12px",
                              borderRadius: "20px",
                              fontSize: "11px",
                              fontWeight: "600",
                            }}
                          >
                            #{etkinlik.tag}
                          </div>

                          <div
                            style={{
                              position: "absolute",
                              bottom: "15px",
                              left: "15px",
                              background: "rgba(0,0,0,0.8)",
                              color: "white",
                              padding: "8px 12px",
                              borderRadius: "12px",
                              fontSize: "12px",
                              fontWeight: "600",
                              display: "flex",
                              alignItems: "center",
                              gap: "6px",
                            }}
                          >
                            <Calendar size={14} />
                            {etkinlik.date} • {etkinlik.time}
                          </div>
                        </div>

                        <div
                          style={{
                            padding: "25px",
                            flex: 1,
                            display: "flex",
                            flexDirection: "column",
                          }}
                        >
                          <div style={{ flex: 1 }}>
                            <h4
                              style={{
                                margin: "0 0 12px 0",
                                fontSize: "20px",
                                fontWeight: "600",
                                lineHeight: "1.3",
                                color: "#1e293b",
                              }}
                            >
                              {etkinlik.title}
                            </h4>

                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                marginBottom: "10px",
                                color: "#64748b",
                                fontSize: "14px",
                              }}
                            >
                              <MapPin
                                size={14}
                                style={{ marginRight: "6px" }}
                              />
                              {etkinlik.location}
                            </div>

                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                marginBottom: "15px",
                                color: "#64748b",
                                fontSize: "14px",
                              }}
                            >
                              <Building2
                                size={14}
                                style={{ marginRight: "6px" }}
                              />
                              {etkinlik.venue}
                            </div>

                            <p
                              style={{
                                color: "#64748b",
                                fontSize: "14px",
                                lineHeight: "1.5",
                                marginBottom: "15px",
                              }}
                            >
                              {etkinlik.description}
                            </p>

                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "15px",
                                marginBottom: "15px",
                                padding: "12px",
                                background: "#f8fafc",
                                borderRadius: "8px",
                              }}
                            >
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "4px",
                                  fontSize: "12px",
                                  color: "#64748b",
                                }}
                              >
                                <Users size={14} />
                                {etkinlik.participants} kişi
                              </div>
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "4px",
                                  fontSize: "12px",
                                  color: "#64748b",
                                }}
                              >
                                <Clock size={14} />
                                {etkinlik.time}
                              </div>
                            </div>
                          </div>

                          <div style={{ marginTop: "auto" }}>
                            <button
                              onClick={() => this.handleEtkinlikView(etkinlik)}
                              style={{
                                background:
                                  "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                                color: "white",
                                padding: "12px 20px",
                                borderRadius: "8px",
                                border: "none",
                                fontSize: "14px",
                                fontWeight: "600",
                                cursor: "pointer",
                                display: "flex",
                                alignItems: "center",
                                gap: "8px",
                                width: "100%",
                                justifyContent: "center",
                                transition: "all 0.3s ease",
                              }}
                            >
                              Detaylar
                              <ChevronRight size={16} />
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>

          <style jsx>{`
            input::placeholder {
              color: white !important;
              opacity: 0.8;
            }

            .row {
              margin-left: -15px;
              margin-right: -15px;
            }

            .col-lg-6,
            .col-xl-4,
            .col-lg-8,
            .col-lg-10,
            .col-lg-2,
            .col-12 {
              padding-left: 15px;
              padding-right: 15px;
            }

            .mb-30 {
              margin-bottom: 30px;
            }

            .etkinlik-card {
              will-change: transform;
              transform: translateZ(0);
              backface-visibility: hidden;
              transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
            }

            .etkinlik-card::before {
              content: "";
              position: absolute;
              top: 0;
              left: 0;
              right: 0;
              bottom: 0;
              border-radius: 20px;
              box-shadow: 0 25px 50px rgba(0, 0, 0, 0.15);
              opacity: 0;
              z-index: -1;
              transition: opacity 0.3s ease;
              will-change: opacity;
            }

            .etkinlik-card:hover {
              transform: translateZ(0) translateY(-6px) scale(1.015);
            }

            .etkinlik-card:hover::before {
              opacity: 1;
            }

            @media (max-width: 1200px) {
              .row {
                margin-left: -10px;
                margin-right: -10px;
              }

              .col-lg-6,
              .col-xl-4,
              .col-lg-8,
              .col-lg-10,
              .col-lg-2,
              .col-12 {
                padding-left: 10px;
                padding-right: 10px;
              }
            }

            @media (max-width: 768px) {
              .mb-30 {
                margin-bottom: 25px;
              }

              .etkinlik-card:hover {
                transform: translateZ(0) translateY(-3px) scale(1.01);
              }
            }

            .etkinlik-card {
              transform: translateZ(0);
            }
          `}</style>
        </div>

        <Footer />
      </>
    );
  }
}
